import axios from 'axios';
import store from '../../store';

const model = () => {
	return {
		id: 			null,

		name:			'',
		customer_id:	null,
		phone:			'',
		email:			'',
		password:		''
	};
};

const save = async (model) => {
	try {
		if (model.id) {
			await axios.put(`/customers/managers/${model.id}`, model);
		} else {
			await axios.post(`/customers/${model.customer_id}/managers`, model);
		}

		return true;
	} catch (err) {
		return false;
	}
};

const dialog = async (model, submit) => {
	store.dispatch('win/push', {
		component: 	'manager-window-view',
		model:		model,
		async submit(model) {
			return await submit(model);
		}
	});
};

const open = async (model, onSave) => {
	dialog(model, async (model) => {
		const r = await save(model);

		if (r) {
			if (onSave) onSave(r);
			return true;
		}

		return false;
	});
};

export default {
	model,
	save,
	open,
	dialog
};